import { render, staticRenderFns } from "./TransactionVia.vue?vue&type=template&id=b03dd528&"
import script from "./TransactionVia.vue?vue&type=script&lang=js&"
export * from "./TransactionVia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports